import { GridColDef, } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Card, Tables } from 'src/shared/components/index';
import { InvoiceData } from '../models';
import { I18N, ROLES } from 'src/shared/constants/constants';
import { FC, useState, useEffect } from 'react';

interface InvoiceManagementTableProps {
  className?: string;
  inputLoginUserRole: string;
  inputInvoiceData: InvoiceData[];
}

const InvoiceManagementTable: FC<InvoiceManagementTableProps> = ({
  inputLoginUserRole,
  inputInvoiceData
}) => {

  const [userTableColumns, setuserTableColumns] = useState([]);
  const { t } = useTranslation(I18N.DEFAULT);

  const [invoiceTotal, setInvoiceTotal] = useState(0);

  useEffect(() => {
    if (inputInvoiceData) {
      let invoiceAmount: number = 0;
      inputInvoiceData.forEach((invoice: InvoiceData) => {
        invoiceAmount += +invoice.amount;
      })
      setInvoiceTotal(invoiceAmount);
    }
  }, [inputInvoiceData]);




  const columns: GridColDef[] = [
    {
      field: ' ',
      headerName: ' ',
      sortable: false,
      type: 'string',
      flex: 0.1
    },
    {
      field: 'invoice no',
      headerName: t('invoice.invoiceno'),
      sortable: false,
      type: 'string',
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.invoiceNo || ''}`;
      },
    },
    {
      field: 'transaction no',
      headerName: t('invoice.transactionno'),
      sortable: false,
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.transactionNo || ''}`;
      },
    },
    {
      field: 'user',
      sortable: true,
      headerName: t('user'),
      flex: 0.8,
      valueGetter: (params) => {
        return `${params.row.createdBy || ''}`;
      }
    },
    {
      field: 'amount',
      sortable: true,
      headerName: t('table.amount'),
      flex: 0.7,
      valueGetter: (params) => {
        return `${params.row.amount || ''} ${params.row.transactionType || ''}`;
      }
    },
    {
      field: 'transaction date',
      sortable: true,
      headerName: t('invoice.transactiondate'),
      flex: 0.9,
      valueGetter: (params) => {
        return `${params.row.transactionDate || ''}`;
      },
    }
  ];

  useEffect(() => {
    if (inputLoginUserRole === ROLES.TENANT_OPERATOR) {
      setuserTableColumns(columns);
    } else {
      setuserTableColumns([...columns]);
    }
  }, []);

  return (
    <>
      <Card className="mb-24">
       
        <Tables
          rows={inputInvoiceData}
          columns={userTableColumns}
          checkboxSelection={false}
        />
         {/* {`Total Amount ${invoiceTotal}`} */}
      </Card>
    </>
  );
};

export default InvoiceManagementTable;
